import { Link } from 'react-router-dom'
import React from 'react'
import "../../../../styles/registrado/noticias/noticias.css"

function Noticias() {
  return (
    <section className="carousel body-noticias" aria-label="Gallery">
      <ol className="carousel__viewport">

        <li id="carousel__slide1"
            tabIndex="0"
            className="carousel__slide slide1">
          <div className="carousel__snapper">
            <h4 className='carrouselTitelInfo'>Los 10 Elementos Básicos de todo Tributo</h4>
            <p className='carrouselParInfo'>
              Un tributo es una obligación de pago de una cierta cantidad de dinero a la Administración Pública, ya sea al estado,
              a las comunidades autónomas o a los ayuntamientos por parte de los ciudadanos y de las empresas.
            </p>
            <Link to="/noticias-slide1" className='carrouselInfoLink'>Seguir leyendo</Link>
            <a href="#carousel__slide4"
               className="carousel__prev">Go to last slide</a>
            <a href="#carousel__slide2"
               className="carousel__next">Go to next slide</a>
          </div>
        </li>

        <li id="carousel__slide2"
            tabIndex="0"
            className="carousel__slide slide2">
          <div className="carousel__snapper">
            <h4 className='carrouselTitelInfo'>Impuesto sobre el Valor Añadido (IVA)</h4>
            <p className='carrouselParInfo'>
              El IVA es un impuesto indirecto que se entrega al gobierno en cada etapa de la producción de un artículo, es decir, 
              cada vez que se genera un valor añadido.
            </p>
            <Link className='carrouselInfoLink' to="/noticias-slide2">Seguir leyendo</Link>
          </div>
          <a href="#carousel__slide1"
             className="carousel__prev">Go to previous slide</a>
          <a href="#carousel__slide3"
             className="carousel__next">Go to next slide</a>
        </li>

        <li id="carousel__slide3"
            tabIndex="0"
            className="carousel__slide slide3">
          <div className="carousel__snapper">
            <h4 className='carrouselTitelInfo'>Actualidad</h4>
            <p className='carrouselParInfo'>
              Así funcionan los impuestos a los productos procesados desde el 1 de noviembre de 2023.
            </p>
            <Link className='carrouselInfoLink' to="/noticias-slide3">Seguir leyendo</Link>
          </div>
          <a href="#carousel__slide2"
             className="carousel__prev">Go to previous slide</a>
          <a href="#carousel__slide4"
             className="carousel__next">Go to next slide</a>
        </li>

        <li id="carousel__slide4"
            tabIndex="0"
            className="carousel__slide slide4">
          <div className="carousel__snapper">
            <h4 className='carrouselTitelInfo'>Impuestos de renta en el 2024</h4>
            <p className='carrouselParInfo'>
              Las razones por las que el próximo año será más costoso pagar el impuesto de renta.
            </p>
            <Link className='carrouselInfoLink' to="/noticias-slide4">Seguir leyendo</Link>
          </div>
          <a href="#carousel__slide3"
             className="carousel__prev">Go to previous slide</a>
          <a href="#carousel__slide1"
             className="carousel__next">Go to first slide</a>
        </li>
      </ol>

      <div className='logo-tributos'>
      </div>

      <aside className="carousel__navigation">
        <ol className="carousel__navigation-list">
          <li className="carousel__navigation-item">
            <a href="#carousel__slide1"
               className="carousel__navigation-button">Go to slide 1</a>
          </li>

          <li className="carousel__navigation-item">
            <a href="#carousel__slide2"
               className="carousel__navigation-button">Go to slide 2</a>
          </li>

          <li className="carousel__navigation-item">
            <a href="#carousel__slide3"
               className="carousel__navigation-button">Go to slide 3</a>
          </li>
          
          <li className="carousel__navigation-item">
            <a href="#carousel__slide4"
               className="carousel__navigation-button">Go to slide 4</a>
          </li>
        </ol>
      </aside>
    </section>
  )
}

export default Noticias